import React, { useCallback, useEffect, useState } from 'react';
import { Create, SimpleForm, usePermissions } from 'react-admin';
import { rolesMatch } from 'utils/user';

export function useHasRole() {
  const { permissions: roles } = usePermissions();
  // const roles = [];
  return useCallback((role) => rolesMatch({ roles, role }), [roles]);
}
